import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { Navbar } from "@/components/Navbar";
import { Footer } from "@/components/Footer";
import { ScrollToTop } from "@/components/ScrollToTop";
import { FloatingCTA } from "@/components/FloatingCTA";
import { CookieBanner } from "@/components/CookieBanner";
import Home from "@/pages/Home";

// Existing service pages
import PonyvaKeszites from "@/pages/PonyvaKeszites";
import PonyvaJavitas from "@/pages/PonyvaJavitas";
import Reklamdekoracio from "@/pages/Reklamdekoracio";
import SatrakMobilraktarak from "@/pages/SatrakMobilraktarak";
import EltetoArnyekolo from "@/pages/EltetoArnyekolo";
import HasznaltPonyvak from "@/pages/HasznaltPonyvak";
import Akciok from "@/pages/Akciok";
import Kapcsolat from "@/pages/Kapcsolat";

// New service pages
import EgyediPonyvak from "@/pages/EgyediPonyvak";
import MedencePonyvak from "@/pages/MedencePonyvak";
import VasszerkezetiMunkak from "@/pages/VasszerkezetiMunkak";
import TeraszTeliesites from "@/pages/TeraszTeliesites";
import PonyvaMobilGarazs from "@/pages/PonyvaMobilGarazs";
import PonyvaTisztitas from "@/pages/PonyvaTisztitas";
import KarpitosBorozes from "@/pages/KarpitosBorozes";
import DigitalisNyomtatas from "@/pages/DigitalisNyomtatas";
import DekoracioEltavolitas from "@/pages/DekoracioEltavolitas";
import PonyvakSzinek from "@/pages/PonyvakSzinek";
import PonyvaKiegeszitok from "@/pages/PonyvaKiegeszitok";
import Rolunk from "@/pages/Rolunk";
import Adatkezeles from "@/pages/Adatkezeles";
import CookieTajekoztato from "@/pages/CookieTajekoztato";
import Palyazatok from "@/pages/Palyazatok";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <ScrollToTop />
        <div className="min-h-screen bg-white text-gray-900 flex flex-col">
          <Navbar />
          <main className="flex-1">
            <Routes>
              <Route path="/" element={<Home />} />
              {/* Gyártás */}
              <Route path="/jarmuponyva-keszites" element={<PonyvaKeszites />} />
              <Route path="/egyedi-ponyvak" element={<EgyediPonyvak />} />
              <Route path="/medence-ponyvak" element={<MedencePonyvak />} />
              <Route path="/satrak-mobilraktarak" element={<SatrakMobilraktarak />} />
              <Route path="/vasszerkezeti-munkak" element={<VasszerkezetiMunkak />} />
              <Route path="/eloteto-arnyekolo" element={<EltetoArnyekolo />} />
              <Route path="/terasz-teliesites" element={<TeraszTeliesites />} />
              <Route path="/ponyva-mobil-garazs" element={<PonyvaMobilGarazs />} />
              {/* Javítás & Szerviz */}
              <Route path="/jarmu-ponyva-javitas" element={<PonyvaJavitas />} />
              <Route path="/ponyva-tisztitas-felujitas" element={<PonyvaTisztitas />} />
              <Route path="/karpitos-borozes" element={<KarpitosBorozes />} />
              <Route path="/ponyva-kiegeszitok" element={<PonyvaKiegeszitok />} />
              {/* Dekoráció */}
              <Route path="/reklamdekoracio" element={<Reklamdekoracio />} />
              <Route path="/digitalis-nyomtatas" element={<DigitalisNyomtatas />} />
              <Route path="/dekoracio-eltavolitas" element={<DekoracioEltavolitas />} />
              {/* Termékek */}
              <Route path="/hasznalt-ponyvak" element={<HasznaltPonyvak />} />
              <Route path="/ponyvak-es-szinek" element={<PonyvakSzinek />} />
              {/* Egyéb */}
              <Route path="/akciok" element={<Akciok />} />
              <Route path="/rolunk" element={<Rolunk />} />
              <Route path="/kapcsolat" element={<Kapcsolat />} />
              {/* Jogi */}
              <Route path="/adatkezelesi-tajekoztato" element={<Adatkezeles />} />
              <Route path="/cookie-tajekoztato" element={<CookieTajekoztato />} />
              <Route path="/palyazatok" element={<Palyazatok />} />
              <Route path="*" element={<Home />} />
            </Routes>
          </main>
          <Footer />
          <FloatingCTA />
          <CookieBanner />
          <Toaster richColors position="top-right" />
        </div>
      </BrowserRouter>
    </div>
  );
}

export default App;
